import './themeDefaults';

export default ({
  modalReact
}) => {
  const {
    backgroundColor, borderColor, borderLeft, borderRadius,
    color, body, width, close, dialogMargin, headerBackground, header,
    closeIconColor, title, success, error, info, warning,
    contentTextAlign, icon, iconSVG, maxWidth, focusColor
  } = modalReact;
  return ({
    dialog: {
      color,
      margin: dialogMargin,
      position: 'relative',
      width: props => props.width || width,
      zIndex: 1,
      maxWidth
    },

    content: {
      backgroundClip: 'border-box',
      backgroundColor,
      border: `1px solid ${borderColor}`,
      borderRadius,
      outline: '0',
      position: 'relative',
      textAlign: contentTextAlign,
      '&:before': {
        ...borderLeft
      }
    },

    header: {
      ...header,
      backgroundColor: ({ variant }) => (
        typeof headerBackground === 'object'
          ? headerBackground[variant] || headerBackground.default
          : headerBackground
      ),
      border: '0',
      borderRadius: `${borderRadius}px ${borderRadius}px 0 0`,
      overflow: 'auto'
    },

    title,
    icon: {
      ...icon,
      '& svg': {
        ...iconSVG,
        fill: ({ variant }) => (iconSVG.fill === 'VARIANT' ? modalReact[variant] : iconSVG.fill)
      }
    },

    close: {
      ...close,
      background: 'transparent',
      opacity: 1,
      cursor: 'pointer',
      position: 'absolute',
      margin: 0,
      padding: 0,
      '&:active': {
        boxShadow: 'none'
      },
      '&:focus': {
        outlineColor: focusColor
      },
      '& svg': {
        fill: closeIconColor
      }
    },

    modalBody: body,

    modalFooter: {
      padding: '10px 20px 20px',
      border: 0,
      textAlign: 'left'
    },

    error: {
      '&:before': {
        borderLeftColor: error
      }
    },
    info: {
      '&:before': {
        borderLeftColor: info
      }
    },
    success: {
      '&:before': {
        borderLeftColor: success
      }
    },
    warning: {
      '&:before': {
        borderLeftColor: warning
      }
    }
  });
};
